import app from 'app';

function COMMON_TABS() {
  return [
    {
      enabled: true,
      label: app.culture.masthead.home,
      path: 'dashboard/home',
    },
    {
      enabled: true,
      label: app.culture.masthead.inProgress,
      path: 'dashboard/inProgress',
    },
    {
      enabled: true,
      label: app.culture.masthead.produced,
      path: 'dashboard/myVideos',
    },
    {
      enabled:
        tk.context.inheritStoryboardsFromChannel &&
        tk.context.user.channelId != 1,
      label: app.culture.masthead.storyboards,
      path: 'dashboard/storyboards',
    },
    {
      enabled: true,
      label: app.culture.masthead.myStoryboards,
      path: 'dashboard/my-storyboards',
    },
    {
      enabled: false,
      label: app.culture.masthead.discover,
      path: 'dashboard/discover',
    },
    {
      enabled: false,
      label: app.culture.masthead.analytics,
      path: 'dashboard/analytics',
    },
  ];
}

function TEMPLETISER_TABS() {
  return [
    {
      enabled: true,
      label: app.culture.masthead.storyboards,
      path: 'dashboard/storyboards',
    },
    {
      enabled: true,
      label: app.culture.masthead.myStoryboards,
      path: 'dashboard/my-storyboards',
    },
    {
      enabled: true,
      label: app.culture.masthead.inProgress,
      path: 'dashboard/inProgress',
    },
  ];
}

export default {
  namespaced: true,

  state() {
    return {
      navigationTabs: COMMON_TABS(),
    };
  },

  getters: {
    enabledNavigationTabs(state) {
      return state.navigationTabs.filter((tab) => tab.enabled);
    },
  },

  mutations: {
    /**
     * Enable/disable navigation tab
     * @param state
     * @param path {string} routePath
     * @param toggle {boolean}
     */
    toggleNavigationTab(state, path, toggle = true) {
      const tab = _.find(state.navigationTabs, (tab) => tab.path === path);
      if (tab) {
        tab.enabled = toggle;
      }
    },

    setTempletiserTabs(state) {
      state.navigationTabs = TEMPLETISER_TABS();
    },
  },

  actions: {},
};
